import request from "root/js/request";

export const getWBDynamicProductsExport = async ({
  product_ids,
  product_ads_min,
  brand_ids,
  seller_ids,
  category_ids,
  wb_search,
  city,
  short_price_sigment = false,
  wb_catalog_url,
  collection_id,
  date_from,
  date_to,
  period,
  limit,
  offset,
  ordering,
  price__gte,
  price__lte,
  in_visual_similar,
  also_buy,
  extra_fields = [
    "proceeds",
    "orders",
    "price",
    "quantity",
    "in_stock_days",
    "out_of_stock_days",
    "in_stock_percent",
    "in_stock_orders_avg",
    "in_stock_proceeds",
    "lost_proceeds",
    "discount",
    "orders_failed",
    "proceeds_failed",
    "old_price",
    "sales",
    "sales_proceeds",
  ].join(),
  ...rest
}) => {
  const response = await request({
    url: "/wb_dynamic/products/export/",
    method: "get",
    params: {
      product_ids,
      product_ads_min,
      brand_ids,
      short_price_sigment,
      seller_ids,
      category_ids,
      collection_id,
      city,
      wb_search,
      wb_catalog_url,
      date_from,
      date_to,
      period,
      limit,
      offset,
      ordering,
      price__gte,
      price__lte,
      extra_fields,
      in_visual_similar,
      also_buy,
      ...rest,
    },
  });
  return response.data;
};

// ---------------------------------------------------------------------------------------------------------------------
export const postWBDynamicProductsExport = async ({
  product_ids,
  extra_fields = "id",
  ...rest
}) => {
  const response = await request({
    url: "/wb_dynamic/products/export/",
    method: "post",
    params: {
      extra_fields,
      ...rest,
    },
    data: {
      product_ids,
    },
  });
  return response.data;
};
